import { render, staticRenderFns } from "./WaitingTehBookingSuccessPopup.vue?vue&type=template&id=708bc7f5&scoped=true"
import script from "./WaitingTehBookingSuccessPopup.vue?vue&type=script&lang=js"
export * from "./WaitingTehBookingSuccessPopup.vue?vue&type=script&lang=js"
import style0 from "./WaitingTehBookingSuccessPopup.vue?vue&type=style&index=0&id=708bc7f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708bc7f5",
  null
  
)

export default component.exports